module.exports = __webpack_public_path__ + "img/f9f87426-60d9-4f97-a372-7cb55b5bf7de.ba306068.webp";